export type AppLanguage = 'zh' | 'pl';

export const LANGUAGE_STORAGE_KEY = 'lottery_admin_language';

export const getInitialLanguage = (): AppLanguage => {
  const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return saved === 'pl' ? 'pl' : 'zh';
};

/** 语言切换：各国母语名称 + 国旗，不随界面语言翻译 */
export const LANGUAGE_OPTIONS: { value: AppLanguage; label: string; flag: string }[] = [
  { value: 'zh', label: '中文', flag: '🇨🇳' },
  { value: 'pl', label: 'Polski', flag: '🇵🇱' },
];

export const getLanguageOption = (lang: AppLanguage) =>
  LANGUAGE_OPTIONS.find((item) => item.value === lang) ?? LANGUAGE_OPTIONS[0];

export const messages = {
  zh: {
    appName: 'Edison-Admin 后台系统',
    admin: '管理员',
    confirm: '确认',
    cancel: '取消',
    login: '登录',
    logout: '退出登录',
    loginTitle: '后台登录',
    loginSubtitle: '请输入账号信息继续管理商品与首页内容',
    loginName: '登录账号',
    password: '登录密码',
    captcha: '图形验证码',
    refreshCaptcha: '点击刷新验证码',
    loginNamePlaceholder: '请输入登录账号',
    passwordPlaceholder: '请输入登录密码',
    captchaPlaceholder: '请输入验证码',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    captchaFailed: '获取验证码失败',
    requiredLoginName: '请输入登录账号',
    requiredPassword: '请输入登录密码',
    requiredCaptcha: '请输入验证码',
    homepageConfig: '首页配置',
    productManagement: '商品管理',
    productList: '商品列表',
    productGroupManagement: '商品组管理',
    specManagement: '规格管理',
    language: '语言',
    operationManual: '操作手册',
    chinese: '中文',
    polish: '波兰语',
    changePassword: '修改密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    oldPasswordPlaceholder: '请输入旧密码',
    newPasswordPlaceholder: '请输入新密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    requiredOldPassword: '请输入旧密码',
    requiredNewPassword: '请输入新密码',
    requiredConfirmPassword: '请再次输入新密码',
    passwordMismatch: '两次输入的新密码不一致',
    changePasswordSuccess: '密码修改成功，请重新登录',
    changePasswordFailed: '修改密码失败',
    notLoggedIn: '请先登录',
    productDetail: '商品详情',
    productGroupDetail: '商品组详情',
    productInfo: '商品信息',
    productGroupInfo: '商品组信息',
    productNameMain: '商品名称（主）',
    productGroupNameMain: '商品组名称（主）',
    multiLangContent: '多语言内容',
    multiLangImages: '图片信息（多语言）',
    multiLangLogo: 'LOGO（多语言）',
    productGroupCode: '商品组编号',
    productGroupName: '商品组名称',
    productGroupTypeLabel: '商品组类型',
    productGroupSpecsTitle: '商品组规格',
    productSpecsTitle: '商品规格',
    fieldProductName: '商品名称',
    fieldProductDesc: '商品描述',
    fieldDeliveryTime: '物流时效',
    fieldSpecialTips: '特殊提示',
    fieldRemark: '备注',
    fieldLogo: 'LOGO',
    fieldDetailImages: '详情图片',
    fieldShowImages: '展示图片',
    fieldChildCategory: '商品子类',
    fieldDeliveryFee: '物流费用',
    fieldProductType: '商品类型',
    fieldStatus: '状态',
    fieldSort: '排序',
    fieldOriginalPrice: '原价',
    fieldDiscountPrice: '折扣价',
    relatedProducts: '关联商品',
    fieldCreateTime: '创建时间',
    fieldUpdateTime: '更新时间',
    fieldModifyTime: '修改时间',
    fieldProductId: '商品ID',
    fieldProductCode: '商品编号',
    fieldProductInfo: '商品信息',
    fieldType: '类型',
    fieldSubType: '子类型',
    fieldPrice: '价格',
    fieldLogistics: '物流',
    fieldActions: '操作',
    relatedProductCount: '关联商品数',
    unitCount: '个',
    emptyNone: '暂无',
    emptyNoDescription: '暂无描述',
    emptyNoRelatedProducts: '暂无关联商品',
    emptyNoImage: '暂无图片',
    actionView: '查看',
    actionEdit: '编辑',
    actionDelete: '删除',
    actionAdd: '新增',
    actionRefresh: '刷新',
    actionSave: '保存',
    actionUpdate: '更新',
    actionEnable: '启用',
    actionDisable: '禁用',
    statusOnline: '已上架',
    statusOffline: '已下架',
    confirmDeleteTitle: '确认删除',
    confirmDeleteProduct: '确定要删除这个商品吗？',
    confirmDeleteProductGroup: '确定要删除这个商品组吗？',
    confirmDeleteSpec: '确定要删除这个规格吗？',
    confirmBatchDeleteTitle: '确认批量删除',
    confirmBatchDeleteProducts: '确定要删除选中的 {count} 个商品吗？',
    confirmOnlineProduct: '确定要上架这个商品吗？',
    confirmOfflineProduct: '确定要下架这个商品吗？',
    confirmOnlineTitle: '确认上架商品',
    confirmOfflineTitle: '确认下架商品',
    actionOnline: '上架',
    actionOffline: '下架',
    msgDeleteSuccess: '删除成功',
    msgDeleteFailed: '删除失败',
    msgSaveSuccess: '保存成功',
    msgUpdateSuccess: '更新成功',
    msgAddSuccess: '新增成功',
    msgOperationFailed: '操作失败',
    msgFetchProductListFailed: '获取商品列表失败',
    msgFetchProductGroupListFailed: '获取商品组列表失败',
    msgFetchRelatedProductsFailed: '获取关联商品失败',
    msgFetchSpecListFailed: '获取规格列表失败',
    msgOnlineSuccess: '商品上架成功',
    msgOfflineSuccess: '商品下架成功',
    msgBatchDeleteSuccess: '批量删除成功',
    msgBatchDeleteFailed: '批量删除失败',
    searchProductName: '搜索商品名称',
    searchProductGroupName: '搜索商品组名称',
    searchSpecName: '搜索规格名称',
    addProduct: '新增商品',
    addProductGroup: '新增商品组',
    paginationRange: '第 {from}-{to} 条/总共 {total} 条',
    specCategory: '分类',
    specContent: '内容',
    specAddChild: '新增子级',
    specEditTitle: '编辑规格',
    specAddTitle: '新增规格',
    specSelectType: '请选择类型',
    specSelectParent: '请选择父级分类',
    specNoParent: '无',
    specSelectLang: '选择显示语言',
    hpModBannerBlockLabel: 'Banner块',
    hpModBannerBlockDesc: '承载多个 Banner 图，通常放在首页顶部',
    hpModBannerBlockDefaultName: 'Banner轮播区',
    hpModBannerBlockDefaultTitle: 'Banner',
    hpModBannerLabel: 'Banner图',
    hpModBannerDesc: '单张 Banner 图片，可配置多语言图片',
    hpModBannerDefaultName: 'Banner图',
    hpModProductBlockLabel: '商品组块',
    hpModProductBlockDesc: '承载多个商品组入口，展示为商品组卡片区域',
    hpModProductBlockDefaultName: '商品组展示区',
    hpModProductBlockDefaultTitle: '热门车型',
    hpModProductLabel: '商品组信息',
    hpModProductDesc: '绑定商品组 ID，点击进入商品组详情',
    hpModProductDefaultName: '商品组入口',
    hpModUnknownLabel: '未知模块',
    hpModUnknownDesc: '未识别模块',
    hpModUnknownDefaultName: '未知模块',
    hpTitle: '首页低代码配置',
    hpSubtitle: '通过组件库、页面画布和属性面板维护用户侧首页模块。',
    hpVisualCanvas: '低代码画布',
    hpTreeView: '树状结构',
    hpComponentLib: '组件库',
    hpPaletteHint: '拖到画布中的可投放区域',
    hpDragToModuleHint: '请拖拽组件到画布中的对应模块',
    hpCanvasTitle: '页面画布',
    hpCanvasHint: '拖拽组件到蓝色区域，或使用组件右上角按钮调整层级和排序',
    hpDesktop: '桌面',
    hpMobile: '手机',
    hpEmptyModules: '暂无首页模块，从左侧拖入一个组件开始配置',
    hpPropsPanel: '属性面板',
    hpPropsSelectHint: '选择画布组件后编辑',
    hpPropsClickHint: '点击画布中的模块查看属性',
    hpPropsSelected: '当前选中：{module}',
    hpParent: '父级',
    hpModuleTitle: '标题',
    hpChildComponents: '子组件',
    hpRoot: '根级',
    hpEditProps: '编辑属性',
    hpFrontendImpact: '前台影响',
    hpBannerI18nTip: '多语言 Banner 图片/视频会影响用户侧当前语言的首页轮播。',
    hpProductGroupClickTip: '选择的商品组决定用户点击卡片后进入哪个商品组详情。',
    hpProductBlockChildTip: '子组件会作为商品组卡片展示在这个商品组块里。',
    hpProductGroupPreview: '商品组内容回显',
    hpProductGroupPreviewHint: '点击下方卡片可以打开商品组详情，方便核对多语言内容和配置。',
  },
  pl: {
    appName: 'Panel Edison-Admin',
    admin: 'Administrator',
    confirm: 'Potwierdź',
    cancel: 'Anuluj',
    login: 'Zaloguj',
    logout: 'Wyloguj',
    loginTitle: 'Logowanie do panelu',
    loginSubtitle: 'Wpisz dane konta, aby zarządzać produktami i stroną główną',
    loginName: 'Login',
    password: 'Hasło',
    captcha: 'Kod z obrazka',
    refreshCaptcha: 'Kliknij, aby odświeżyć kod',
    loginNamePlaceholder: 'Wpisz login',
    passwordPlaceholder: 'Wpisz hasło',
    captchaPlaceholder: 'Wpisz kod',
    loginSuccess: 'Zalogowano',
    loginFailed: 'Logowanie nie powiodło się',
    captchaFailed: 'Nie udało się pobrać kodu',
    requiredLoginName: 'Wpisz login',
    requiredPassword: 'Wpisz hasło',
    requiredCaptcha: 'Wpisz kod z obrazka',
    homepageConfig: 'Konfiguracja strony',
    productManagement: 'Produkty',
    productList: 'Lista produktów',
    productGroupManagement: 'Grupy produktów',
    specManagement: 'Specyfikacje',
    language: 'Język',
    operationManual: 'Instrukcja',
    chinese: '中文',
    polish: 'Polski',
    changePassword: 'Zmień hasło',
    oldPassword: 'Stare hasło',
    newPassword: 'Nowe hasło',
    confirmPassword: 'Potwierdź nowe hasło',
    oldPasswordPlaceholder: 'Wpisz stare hasło',
    newPasswordPlaceholder: 'Wpisz nowe hasło',
    confirmPasswordPlaceholder: 'Wpisz ponownie nowe hasło',
    requiredOldPassword: 'Wpisz stare hasło',
    requiredNewPassword: 'Wpisz nowe hasło',
    requiredConfirmPassword: 'Wpisz ponownie nowe hasło',
    passwordMismatch: 'Nowe hasła nie są takie same',
    changePasswordSuccess: 'Hasło zmienione. Zaloguj się ponownie',
    changePasswordFailed: 'Zmiana hasła nie powiodła się',
    notLoggedIn: 'Najpierw się zaloguj',
    productDetail: 'Szczegóły produktu',
    productGroupDetail: 'Szczegóły grupy produktów',
    productInfo: 'Informacje o produkcie',
    productGroupInfo: 'Informacje o grupie produktów',
    productNameMain: 'Nazwa produktu (główna)',
    productGroupNameMain: 'Nazwa grupy produktów (główna)',
    multiLangContent: 'Treść wielojęzyczna',
    multiLangImages: 'Zdjęcia (wiele języków)',
    multiLangLogo: 'LOGO (wiele języków)',
    productGroupCode: 'ID grupy produktów',
    productGroupName: 'Nazwa grupy produktów',
    productGroupTypeLabel: 'Typ grupy produktów',
    productGroupSpecsTitle: 'Specyfikacje grupy produktów',
    productSpecsTitle: 'Specyfikacje produktu',
    fieldProductName: 'Nazwa produktu',
    fieldProductDesc: 'Opis produktu',
    fieldDeliveryTime: 'Czas dostawy',
    fieldSpecialTips: 'Ważna informacja',
    fieldRemark: 'Uwagi',
    fieldLogo: 'LOGO',
    fieldDetailImages: 'Zdjęcia szczegółowe',
    fieldShowImages: 'Zdjęcia prezentacyjne',
    fieldChildCategory: 'Podtyp produktu',
    fieldDeliveryFee: 'Koszt dostawy',
    fieldProductType: 'Typ produktu',
    fieldStatus: 'Status',
    fieldSort: 'Kolejność',
    fieldOriginalPrice: 'Cena regularna',
    fieldDiscountPrice: 'Cena promocyjna',
    relatedProducts: 'Powiązane produkty',
    fieldCreateTime: 'Utworzono',
    fieldUpdateTime: 'Zaktualizowano',
    fieldModifyTime: 'Zmodyfikowano',
    fieldProductId: 'ID produktu',
    fieldProductCode: 'Kod produktu',
    fieldProductInfo: 'Informacje o produkcie',
    fieldType: 'Typ',
    fieldSubType: 'Podtyp',
    fieldPrice: 'Cena',
    fieldLogistics: 'Dostawa',
    fieldActions: 'Akcje',
    relatedProductCount: 'Liczba powiązanych produktów',
    unitCount: 'szt.',
    emptyNone: 'Brak',
    emptyNoDescription: 'Brak opisu',
    emptyNoRelatedProducts: 'Brak powiązanych produktów',
    emptyNoImage: 'Brak obrazu',
    actionView: 'Podgląd',
    actionEdit: 'Edytuj',
    actionDelete: 'Usuń',
    actionAdd: 'Dodaj',
    actionRefresh: 'Odśwież',
    actionSave: 'Zapisz',
    actionUpdate: 'Aktualizuj',
    actionEnable: 'Włącz',
    actionDisable: 'Wyłącz',
    statusOnline: 'Opublikowany',
    statusOffline: 'Wycofany',
    confirmDeleteTitle: 'Potwierdź usunięcie',
    confirmDeleteProduct: 'Czy na pewno usunąć ten produkt?',
    confirmDeleteProductGroup: 'Czy na pewno usunąć tę grupę produktów?',
    confirmDeleteSpec: 'Czy na pewno usunąć tę specyfikację?',
    confirmBatchDeleteTitle: 'Potwierdź usunięcie zbiorcze',
    confirmBatchDeleteProducts: 'Czy na pewno usunąć wybrane produkty ({count})?',
    confirmOnlineProduct: 'Czy na pewno opublikować ten produkt?',
    confirmOfflineProduct: 'Czy na pewno wycofać ten produkt?',
    confirmOnlineTitle: 'Potwierdź publikację',
    confirmOfflineTitle: 'Potwierdź wycofanie',
    actionOnline: 'Opublikuj',
    actionOffline: 'Wycofaj',
    msgDeleteSuccess: 'Usunięto',
    msgDeleteFailed: 'Usuwanie nie powiodło się',
    msgSaveSuccess: 'Zapisano',
    msgUpdateSuccess: 'Zaktualizowano',
    msgAddSuccess: 'Dodano',
    msgOperationFailed: 'Operacja nie powiodła się',
    msgFetchProductListFailed: 'Nie udało się pobrać listy produktów',
    msgFetchProductGroupListFailed: 'Nie udało się pobrać listy grup produktów',
    msgFetchRelatedProductsFailed: 'Nie udało się pobrać powiązanych produktów',
    msgFetchSpecListFailed: 'Nie udało się pobrać listy specyfikacji',
    msgOnlineSuccess: 'Produkt opublikowany',
    msgOfflineSuccess: 'Produkt wycofany',
    msgBatchDeleteSuccess: 'Usunięto zbiorczo',
    msgBatchDeleteFailed: 'Zbiorcze usuwanie nie powiodło się',
    searchProductName: 'Szukaj nazwy produktu',
    searchProductGroupName: 'Szukaj nazwy grupy produktów',
    searchSpecName: 'Szukaj nazwy specyfikacji',
    addProduct: 'Dodaj produkt',
    addProductGroup: 'Dodaj grupę produktów',
    paginationRange: 'Od {from} do {to} z {total}',
    specCategory: 'Kategoria',
    specContent: 'Treść',
    specAddChild: 'Dodaj element podrzędny',
    specEditTitle: 'Edytuj specyfikację',
    specAddTitle: 'Dodaj specyfikację',
    specSelectType: 'Wybierz typ',
    specSelectParent: 'Wybierz kategorię nadrzędną',
    specNoParent: 'Brak',
    specSelectLang: 'Wybierz język wyświetlania',
    hpModBannerBlockLabel: 'Blok banera',
    hpModBannerBlockDesc: 'Zawiera wiele banerów, zwykle na górze strony głównej',
    hpModBannerBlockDefaultName: 'Karuzela banerów',
    hpModBannerBlockDefaultTitle: 'Banner',
    hpModBannerLabel: 'Baner',
    hpModBannerDesc: 'Pojedynczy baner z wielojęzycznymi obrazami',
    hpModBannerDefaultName: 'Baner',
    hpModProductBlockLabel: 'Blok grup produktów',
    hpModProductBlockDesc: 'Wiele wejść do grup produktów — wyświetlane jako karty',
    hpModProductBlockDefaultName: 'Strefa grup produktów',
    hpModProductBlockDefaultTitle: 'Popularne modele',
    hpModProductLabel: 'Informacje o grupie produktów',
    hpModProductDesc: 'Powiązanie z ID grupy — kliknięcie otwiera szczegóły grupy',
    hpModProductDefaultName: 'Wejście do grupy produktów',
    hpModUnknownLabel: 'Nieznany moduł',
    hpModUnknownDesc: 'Nierozpoznany moduł',
    hpModUnknownDefaultName: 'Nieznany moduł',
    hpTitle: 'Konfiguracja strony (low-code)',
    hpSubtitle: 'Zarządzaj modułami strony głównej przez bibliotekę komponentów, obszar i panel właściwości.',
    hpVisualCanvas: 'Obszar low-code',
    hpTreeView: 'Struktura drzewa',
    hpComponentLib: 'Biblioteka komponentów',
    hpPaletteHint: 'Przeciągnij do obszaru docelowego na kanwie',
    hpDragToModuleHint: 'Przeciągnij komponent do odpowiedniego modułu na kanwie',
    hpCanvasTitle: 'Obszar strony',
    hpCanvasHint: 'Przeciągnij komponenty do niebieskich stref lub użyj przycisków w rogu modułu',
    hpDesktop: 'Desktop',
    hpMobile: 'Telefon',
    hpEmptyModules: 'Brak modułów — przeciągnij komponent z lewej strony',
    hpPropsPanel: 'Panel właściwości',
    hpPropsSelectHint: 'Wybierz komponent na kanwie, aby edytować',
    hpPropsClickHint: 'Kliknij moduł na kanwie, aby zobaczyć właściwości',
    hpPropsSelected: 'Wybrano: {module}',
    hpParent: 'Nadrzędny',
    hpModuleTitle: 'Tytuł',
    hpChildComponents: 'Komponenty podrzędne',
    hpRoot: 'Poziom główny',
    hpEditProps: 'Edytuj właściwości',
    hpFrontendImpact: 'Wpływ na front',
    hpBannerI18nTip: 'Wielojęzyczne banery (obraz/wideo) wpływają na karuzelę na stronie głównej.',
    hpProductGroupClickTip: 'Wybrana grupa produktów decyduje, do której strony szczegółów trafi użytkownik.',
    hpProductBlockChildTip: 'Elementy podrzędne są wyświetlane jako karty grup produktów.',
    hpProductGroupPreview: 'Podgląd grupy produktów',
    hpProductGroupPreviewHint: 'Kliknij kartę, aby otworzyć szczegóły grupy i zweryfikować treści.',
  },
} as const;

/** 简单模板替换：t('paginationRange', { from: 1, to: 20, total: 100 }) */
export const formatMessage = (
  lang: AppLanguage,
  key: MessageKey,
  params?: Record<string, string | number>
) => {
  let text: string = messages[lang][key] || messages.zh[key] || key;
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    });
  }
  return text;
};

export type MessageKey = keyof typeof messages.zh;
